import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_accgrade'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING()
    }
  }
}
